import React, {useEffect, useState} from 'react';
import CustomSelect from '../../form/CustomSelect'
import {useTranslation} from "react-i18next";


const SelectProgram = ({availablePrograms,selectedProgram, setSelectedProgram}) => {

    const { t } = useTranslation();

    const [options, setOptions] = useState([]);

    useEffect(() => {
        let optionsArray = [];
        availablePrograms.forEach((program) => {
            optionsArray.push({ value: program.id, label: program.name })
        })
        setOptions(optionsArray);
    }, [availablePrograms]);

    const handleChange = (option) => {
       setSelectedProgram(option.value);
    };


    return (
        <div className="step">
            <div className="select-program">
                {availablePrograms.length ? <>
                    <h2>{t("Select a Program")}</h2>
                    <p className="mb-5">{t("When adding cardholders, accounts are created and linked to them. Please select the active program for these accounts.")}</p>
                    <div className="input-wrapper">
                        <CustomSelect
                            placeholder={<div>{t("Select program")}</div>}
                            options={options}
                            onChange={handleChange}
                        />
                    </div>
                </> : t("Loading available programs...")}
            </div>
        </div>
    );
};

export default SelectProgram;
